import React, { FC, useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs'
import { toast } from 'material-react-toastify'
import { Drawer } from '@mui/material'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import InfiniteScroll from 'react-infinite-scroll-component'
import { AiOutlineLoading } from 'react-icons/ai'
import { ReviewList } from './ReviewList'
// import { Rating } from './Rating'
import { get2HoursLocalReviews } from './utils'
import addOrReplaceParam from '../../../utils/addQueryParam'
import { BASE_URL, SORT_ARR } from './config'
import { RatingBox } from './RatingBox'

// 简易loading
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Loading: FC = () => (
  <div
    className="flex justify-center items-center w-full sm:w-96 py-4"
    style={{ height: '56px' }}
  >
    <span className="animate-spin inline-block">
      <AiOutlineLoading size={24} />
    </span>
  </div>
)

// eslint-disable-next-line import/prefer-default-export
export const ReviewListDrawer: FC<{
  figure: any
  drawerOpen: boolean
  onClose: any
  // productId: string | number
  pHandle: string
  reviewReportData: any
  isExtension?: boolean
}> = ({
  figure,
  drawerOpen,
  onClose,
  // productId,
  pHandle,
  reviewReportData,
  isExtension = false,
}) => {
  const size =
    typeof window !== 'undefined'
      ? Math.max(+((window?.innerHeight ?? 1000) / 100).toFixed(0), 10)
      : 10 // 每页条数
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [openTime, setOpenTime] = useState(dayjs())
  const [pageIndex, setPageIndex] = useState(1)
  const [reviewCacheCount, setReviewCacheCount] = useState(0)
  const [currentFilter, setCurrentFilter] = useState('')
  const [reviewAverage, setReviewAverage] = useState(0)
  const [reviewCount, setReviewCount] = useState<any>(null)
  const [reviewList, setReviewList] = useState<any[]>([])
  const [reviewFigure, setReviewFigure] = useState<any>({})
  const controllerRef = useRef<AbortController | null>()
  const [showPercentBox, setShowPercentBox] = useState<boolean>(false)
  const handleClose = () => {
    if (controllerRef.current) {
      controllerRef.current.abort()
    }
    onClose(dayjs().diff(openTime, 'milliseconds'))
  }

  async function getReviewList(
    sortKey?: string | number,
    page?: number,
    moreParam?: string
  ) {
    if (controllerRef.current) {
      controllerRef.current.abort()
    }
    controllerRef.current = new AbortController()
    try {
      setIsLoading(true)
      let param = addOrReplaceParam(
        `${BASE_URL}/review?${moreParam}`,
        'handle',
        pHandle
      )
      param = sortKey ? addOrReplaceParam(param, 'sortKey', sortKey) : param
      param = page
        ? addOrReplaceParam(param, 'offset', Math.max(page - 1, 0) * size)
        : param
      // const param = addOrReplaceParam(`${BASE_URL}/reviews`, 'productId', productId)
      // const res = await fetch(`${param}&limit=3`)
      const res = await fetch(`${param}&limit=${size}`, {
        signal: controllerRef.current?.signal,
      })
      if (res.status === 200 && res.ok) {
        const data = await res.json()
        if (data.status === 200) {
          setReviewCount(data.body.count)
          setReviewAverage(data.body.average)
          const newReviewList = [...reviewList, ...data.body.items]
          setReviewList(newReviewList)
          const fig = data.body.reviewFit
          if (fig && fig.total > 0) {
            const computedPercent = (
              total: number,
              arrs: number[],
              fixed = 0
            ) => arrs.map((i) => Number(((i * 100) / total).toFixed(fixed)))
            const [smPer, lgPer] = computedPercent(fig.total, [
              fig.small,
              // fig.true_to_size,
              fig.large,
            ])
            const truePer = 100 - smPer - lgPer
            setReviewFigure({ ...fig, smPer, truePer, lgPer })
            setShowPercentBox(true)
          }
          console.log(reviewList, data.body.items)
          setPageIndex(
            Math.ceil((newReviewList.length - reviewCacheCount) / size) || 1
          )
          controllerRef.current = null
          // setPageIndex(pageIndex + 1)
        } else {
          toast.error(
            data.message ||
              'Server error, please feed back through the customer service plug-in'
          )
        }
      }
    } catch (e: any) {
      console.log(e)
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        toast.dark(
          'Oops, fetch data failed. Please check your network and try again.'
        )
      }
    }
    setIsLoading(false)
  }

  function handleSortTypeSelect(e: any) {
    setIsLoading(true)
    setCurrentFilter(e.target.value)
    setReviewList([])
    window?.sensors?.track('ReviewSortMethodClick', {
      ...reviewReportData,
      // @ts-ignore
      sort_method: SORT_ARR.find((item) => item.value === e.target.value).label,
    })
    console.log('ReviewSortMethodClick', {
      ...reviewReportData,
      // @ts-ignore
      sort_method: SORT_ARR.find((item) => item.value === e.target.value).label,
    })
  }

  useEffect(() => {
    if (drawerOpen) {
      // setPageIndex(1)
      setReviewList([])
      setCurrentFilter(SORT_ARR[0].value)
    } else {
      setReviewList([])
      setCurrentFilter('')
      console.log('close')
    }
  }, [drawerOpen])

  // useEffect(() => {
  //   if (drawerOpen) {
  //     setPageIndex(
  //       Math.ceil((reviewList.length - reviewCacheCount) / size) || 1
  //     )
  //   }
  // }, [reviewList.length])

  useEffect(() => {
    if (drawerOpen) {
      setReviewList([])
      setPageIndex(1)
      getReviewList(undefined, 1, currentFilter)
    }
  }, [currentFilter])

  useEffect(() => {
    if (typeof window === 'undefined' || !drawerOpen) return
    setOpenTime(dayjs())
    const reviewCache = get2HoursLocalReviews(pHandle)
    const IdCacheList = reviewCache.map((i) => i.id)
    const excludeCacheIdReviews = reviewList.filter(
      (i) => !IdCacheList.includes(i.id)
    )
    const finalList = [...reviewCache, ...excludeCacheIdReviews]
    setReviewList(finalList)
    setReviewCacheCount(reviewCache.length)
    // setReviewList([])
  }, [drawerOpen, reviewList.length])

  return (
    <Drawer
      open={drawerOpen}
      anchor="right"
      onClose={handleClose}
      sx={{ '.MuiDrawer-paper': { overflow: 'hidden' } }}
    >
      <div className="block w-full py-7">
        <div className="flex justify-center items-center border-b-1 border-gray-100 w-full h-14 fixed sm:w-96 top-0 z-10 px-3 bg-white text-black font-semibold">
          Reviews
          {reviewCount ? ` (${reviewCount > 999 ? '999+' : reviewCount})` : ''}
          <div
            className="absolute left-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
            onClick={handleClose}
          >
            <svg width="11" height="20" viewBox="0 0 11 20" fill="none">
              <path
                d="M9.54907 1.51465L1.06379 9.99993L9.54907 18.4852"
                stroke="black"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col flex-wrap w-screen sm:w-96"
        style={{ height: 'calc(100vh - 56px)' }}
      >
        <div className="flex flex-grow-0 justify-between items-center w-full pl-0 bg-tag-grayf5">
          <RatingBox
            reviewList={reviewList}
            reviewFigure={reviewFigure}
            reviewAverage={reviewAverage}
            showPercentBox={showPercentBox}
          />
        </div>
        <div className="flex border-b border-tag-grayef">
          <div className="inline-flex flex-1 my-2 px-2 items-center justify-end text-xs">
            <select
              onChange={handleSortTypeSelect}
              defaultValue={SORT_ARR[0].value}
              className="bg-transparent outline-none h-6 mr-0.5 text-12 text-right font-medium cursor-pointer"
            >
              {SORT_ARR.map((i, idx: number) => (
                <option value={i.value} key={idx}>
                  {i.label}
                </option>
              ))}
            </select>
            <MdOutlineKeyboardArrowDown color="inherit" size={16} />
          </div>
        </div>
        <div
          className="w-full flex-1 overflow-y-auto"
          id="reviewListInfiniteScroll"
        >
          {isLoading && !reviewList.length ? <Loading /> : null}
          {reviewList.length ? (
            <InfiniteScroll
              scrollableTarget="reviewListInfiniteScroll"
              key={currentFilter}
              next={() => {
                console.log('next ', pageIndex + 1)
                setTimeout(
                  () => getReviewList(undefined, pageIndex + 1, currentFilter),
                  50
                )
              }}
              hasMore={Math.max(pageIndex, 0) * size < reviewCount}
              loader={<Loading />}
              dataLength={reviewList.length - reviewCacheCount || size}
            >
              <ReviewList
                figure={figure}
                reviewList={reviewList}
                className="px-3"
                isExtension={isExtension}
              />
            </InfiniteScroll>
          ) : null}
          {!isLoading && Math.max(pageIndex, 0) * size >= reviewCount && (
            <div className="w-full py-4 text-center text-gray-400 text-xs font-medium">
              This is the end
            </div>
          )}
        </div>
      </div>
    </Drawer>
  )
}
